export enum EStripe {
  getConsultantStripeDashboardLink = 'stripe/getConsultantStripeDashboardLink',
  getConsultantStripeAccountLink = 'stripe/getConsultantStripeAccountLink',
  getCustomerStripeDashboardLink = 'stripe/getCustomerStripeDashboardLink',
}
